/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import styled from 'styled-components';

import Check from './Check.svg?react';

export const PlanFeaturesListItemContainerStyled = styled.div`
	gap: 12px;
	display: flex;
	align-items: flex-start;
`;

export const PlanFeatureTextStyled = styled.p<{ isIncludedInFree: boolean; active: boolean }>`
	margin: 0;
	width: 100%;
	color: #262626;
	font-size: 16px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 14px;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 16px;
	}
`;

export const IconStyled = styled(Check)<{ isActive: boolean }>`
	fill: ${props => (props.isActive ? `#237804` : `#1890FF`)};
	width: 8px;
	height: 8px;
	color: ${props => (props.isActive ? `#237804` : `#1890FF`)};
`;

export const IconContainerStyled = styled.div<{ isActive: boolean }>`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 6px;
	min-width: 14px;
	height: 14px;
	border-radius: 50%;
	background-color: ${props => (props.isActive ? `#d9f7be` : `#E6F7FF`)};
`;
